import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ImprovementrequestService } from 'src/app/core/services/improvement-request-service';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ImprovementRequestSearch } from 'src/app/model/ImprovementRequestSearch';
import { ProductDto } from 'src/app/model/ProductDto';
import { ProductRelease, StatoRelease } from 'src/app/model/ProductRelease';
import { ReleaseNotesComponent } from '../release-notes/release-notes.component';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { validateStringArray } from 'src/app/core/services/chipsSearch';
import { ProjectBugReleases } from 'src/app/model/ProjectBugReleases';
import { BugSeverity, InprovementStatus, StatoAnomalia } from 'src/app/model/customer';

@Component({
  selector: 'ms-bugs-improvement-finder',
  templateUrl: './bugs-improvement-finder.component.html',
  styleUrls: ['./bugs-improvement-finder.component.scss']
})
export class BugsImprovementFinderComponent implements OnInit {
  @ViewChild('chipList') chipList: MatChipList;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  _releaseNotes: ReleaseNotesComponent;
  public cmsObj: CmsObject[];
  constructor(
    private _formBuilder: FormBuilder,
    private improvementrequestService: ImprovementrequestService,
    private productDownloadService: ProductDownloadService,
    public cmsService: CmsService,
    public workFlow: WorkFlowService,
  ) { }

  readonly filters = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null),
  });

  readonly bugFilters = new FormGroup({
    status: new FormControl(null),
    severity: new FormControl(null),
  });

  readonly improvementFilters = new FormGroup({
    status: new FormControl(null),
  });

  data = { tags: [] }
  search = this._formBuilder.group({
    product: '',
    release: '',
    functionalArea: '',
    type: '',
    searchString: this._formBuilder.array(this.data.tags, this.validateArrayNotEmpty)
  });

  improvementRequestSearch: ImprovementRequestSearch = null;
  releases: string[] = [];
  productReleases: ProductRelease[] = [];
  productDto: ProductDto = null;
  bugsReportReleseNotesDisclaimer: string;
  isLoading: boolean = false;
  isLoadingReleases: boolean = false;
  lastProduct: '';
  descriptionToShow: string;
  releaseComponentLoading: boolean = false;

  async ngOnInit() {
    this.isLoading = true;
    this.descriptionToShow = this.workFlow.getLanguageForCms() == 'it-IT' ? 'Description' : 'EnglishDescription';
    await this.getCmsObj();
    this.improvementrequestService.getImpReqSearchData()
    .then((res) => {
      if(!res.Result || !res.Content || !res.Content[0]) throw new Error('Error to find products and functional areas')

      res.Content[0].FunctionalAreas.forEach((fa) => { if(!fa.EnglishDescription) fa.EnglishDescription = fa.Description})
      res.Content[0].FunctionalAreas = res.Content[0].FunctionalAreas.sort((a,b) => a[this.descriptionToShow].localeCompare(b[this.descriptionToShow]) )

      this.improvementRequestSearch = res.Content[0];
      this.isLoading = false
    })
    .catch((err) => {
      this.isLoading = false
    })
    this.search.valueChanges.debounceTime(250).subscribe(value => { this.setVisibleRequests(value) })
  }

  initSearchString(tag: string): FormControl {
    return this._formBuilder.control(tag);
  }

  validateArrayNotEmpty(c: FormControl) {
    let values = c.value as string[]
    return validateStringArray(values) ? null : { validateArrayNotEmpty: { valid: false } }
  }

  add(event: MatChipInputEvent, form: FormGroup): void {
    const input = event.input;
    let value = event.value;

    if(value.split(/\s*[^a-zA-Z0-9,]\s*|,/).filter(s => s.trim().length > 0).length > 45)
      value = value.split(/\s*[^a-zA-Z0-9,]\s*|,/).filter(s => s.trim().length > 0).slice(0, 45).join(' ');

    if ((value || '').trim()) {
      const control = <FormArray>form.get('searchString');
      control.push(this.initSearchString(value.trim()));
      control.setValue(this.setSearchString(control.value));
    }
    if (input) {
      input.value = '';
    }
  }

  remove(form, index) {
    form.get('searchString').removeAt(index);
  }

  setSearchString(tags: string[]): string[]{
    let orderedNumerciStrings: string[] = [];
    let orderedStrings: string[] = [];
    tags.forEach((tag) => {
      if(/^[0-9]+$/.test(tag))
        orderedNumerciStrings.push(tag)
      else
        orderedStrings.push(tag)
    })
    return orderedNumerciStrings.sort((a,b) => b.length - a.length).concat(orderedStrings.sort((a,b) => b.length - a.length))
  }

  async getCmsObj() {
    this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'bugsReportReleseNotes');
    this.bugsReportReleseNotesDisclaimer = this.cmsObj.find((x) => x.ContentName == 'bugsReportReleseNotes.Disclaimer').ContentTranslation;
  }

  enabledInput(): string[]{
    let enabledInput: string[] = ['product', 'type'];
    if(this.search.value['product']) { enabledInput.push('functionalArea'); enabledInput.push('release') }
    if(this.isButtonConditionsActive()) enabledInput.push('button')
    return enabledInput;
  }

  isButtonConditionsActive(): boolean{
    if(this.search.value['product'] && this.search.value['release'] && this.search.value['type'])
      return true
    else if( this.search.value['searchString'].length > 0 && validateStringArray(this.search.value['searchString']) && this.search.value['type'] ){
      if(this.search.value['product']) return true
      else {
        let tags = this.search.value['searchString'] as string[]
        return tags.some((tag) => {
          if(/^[0-9]+$/.test(tag))
            return true
        }) ?? false
      }
    }
    return false
  }

  disableButton(): boolean {
    return (
      !this.search.value['product'] ||
      !this.search.value['functionalArea'] ||
      !this.search.value['release'] ||
      !this.search.value['type']
    )
  }

  searchBugsAndImprovement(){
    this.productDto = new ProductDto(this.search.value['product'] ?? '', this.search.value['product'] ?? '', this.search.value['release'] ?? '', this.productReleases.find(pr => pr.ReleaseNr == this.search.value['release'])?.PublicationDate ?? null)
  }

  searchString(){
    return this.search.value['searchString']
  }

  setVisibleRequests(parametes: object){
    this.productDto = null;
    if(parametes['product'] != this.lastProduct){
      this.search.controls['release'].setValue('')
      if(parametes['product']){
        this.isLoadingReleases = true;
        this.productDownloadService.getProductReleasesForKnowledge(parametes['product'])
        .then((res) => {
          if(res.Result && res.Content){
            this.releases = res.Content.sort((a,b) => b.ReleaseNr.localeCompare(a.ReleaseNr) ).map(rel => rel.ReleaseNr)
            this.productReleases = res.Content
          }
          this.isLoadingReleases = false
        })
        .catch(err => {
          this.isLoadingReleases = false
        })
      }
    }
    this.lastProduct = parametes['product']
  }

  showBugs(){
    return(
      this.search.value['type'] == 'bug'
    )
  }
  showImprovements(){
    return (
      this.search.value['type'] == 'improvement' &&
      !this.releaseComponentLoading
    )
  }

  getSelectedFunctionalArea(){
    return this.search.value['functionalArea'] ?? ''
  }

  selectNone(value: string, input: string){
    if(value == undefined) {
      this.search.controls[input].setValue('none')
      this.setVisibleRequests(this.search.value)
    }
  }

  getTagSubStr(value: string): string{
    return value.length > 120 ? `${value.substring(0,120)}...` : value
  }

  clearSearch(){
    this.search.controls['searchString'].setValue('');
  }

  getBugStatuses(): string[] {
    return Object.keys(StatoAnomalia).filter(status => isNaN(Number(status)) && this.getBugStatusNumber(status) != 0);
  }
  getBugStatusNumber(statusString: string): number {
    return StatoAnomalia[statusString] ?? ''
  }

  getImprovementStatuses(): string[] {
    return Object.keys(InprovementStatus).filter(status => isNaN(Number(status)) && this.getImprovementStatusNumber(status) != 0);
  }
  getImprovementStatusNumber(statusString: string): number {
    return InprovementStatus[statusString] ?? ''
  }

  getBugsSeverities(): string[] {
    return Object.keys(BugSeverity).filter(severity => isNaN(Number(severity)) && this.getBugSeverityNumber(severity) != 0);
  }
  getBugSeverityNumber(severityString: string): number {
    return BugSeverity[severityString] ?? ''
  }

}
